import React from "react";
import "./ScreenImage.css";

export default function ScreenImage(props) {
  const currentSlide = props.currentSlide;
  
  if (!currentSlide.screenImage) {
    return null;
  }

  const styles = {
    container: {
      position: "fixed",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 200,
      flexDirection: "column",
      opacity: currentSlide.screenImage ? "1" : "0",
      pointerEvents: "none",
      width: "50vw",
      height: "50vh",
      left: "5vw",
      top: "10vh",
      WebkitTransition: "opacity 2s",
    },
    image: {
      height: "100%",
    },
  };

  return (
    <div id="full-screen-text" style={styles.container}>
      <img
        src={currentSlide.screenImage}
        style={styles.image}
        className="fade-in"
        alt="Screen content"
      />
    </div>
  );
}